import * as styledComponents from 'styled-components';
export * from './models';
export * from './mixins';
export * from './utils';
export { css, createGlobalStyle, keyframes };
const { default: styled, css, createGlobalStyle, keyframes, } = styledComponents;
export default styled;
//# sourceMappingURL=index.js.map